require('/opt/odin/app/frontend/components/banner/signup_banner/index.module.scss');module.exports = "../../app/cells/components/banner/signup_banner/show.erb";